export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5338.74799a63.jpg";